import { Component, Prop, Watch } from 'vue-property-decorator'
import Template from '@/components/BaseCurd/template'
import {
  WarehouseMaterialStockServiceProxy
} from '@/service-proxies/app-v2/warehouse.service-proxies'
import { MaterialTypeServiceProxy, MaterialServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'

const wmsp = new WarehouseMaterialStockServiceProxy()
const mtsp = new MaterialTypeServiceProxy()
const msp = new MaterialServiceProxy()

@Component
export default class Material extends Template {
  @Prop({ default: '' }) readonly areaId: string
  @Prop({ default: '' }) readonly locationId: string
  @Prop({ default: 0 }) readonly isBind: Number

  get columns() {
    return [
      {
        title: this.$t('page_tenant_operation'),
        key: 'action',
        fix: 'left',
        width: 80,
        customRender: (text, record) => {
          return (
            <a-popconfirm title={this.$t('page_resource_pool_confirm_delete')}
                          onConfirm={() => {
                            this.deleteSingleData(record.id)
                          }}
                          okText={this.$t('yes')}
                          cancelText={this.$t('no')}
            >
              <a class="del-color" v-acl={this.getAcl(this.acl.delete)}>
                {this.$t('delete')}
              </a>
            </a-popconfirm>
          )
        }
      },
      //序号
      {
        title: this.$t('page_mdc_setting_index'), dataIndex: 'order', width: 100, ellipsis: true
      },
      // 物料编码
      { title: this.$t('page_business_material_code'), dataIndex: 'code', width: 100, ellipsis: true },
      // 物料名称
      { title: this.$t('page_business_material_name'), dataIndex: 'name', width: 100, ellipsis: true },
      // 是否必检
      {
        title: this.$t('page_business_necessary_to_check'), dataIndex: 'isMustCheck', width: 100, ellipsis: true,
        customRender: (text) => text ? this.$t('page_business_necessary_to_check_true') : this.$t('page_business_necessary_to_check_false')
      },
      // 额定库存
      { title: this.$t('page_business_rated_stock'), dataIndex: 'lowerLimit', width: 100, ellipsis: true },
      // 安全库存
      { title: this.$t('page_business_safety_stock'), dataIndex: 'upperLimit', width: 100, ellipsis: true },
      // 物料类型
      {
        title: this.$t('page_business_material_type'),
        dataIndex: 'typeId',
        width: 100,
        ellipsis: true,
        customRender: (text) => {
          if (this.materialTypeList.find(item => item.value === text)) {
            return this.materialTypeList.find(item => item.value === text).label
          } else {
            return ''
          }
        }
      },
      // 计量单位
      {
        title: this.$t('page_business_unit_of_measurement'), dataIndex: 'unit', width: 100, ellipsis: true
      },
      // 材质
      { title: this.$t('page_business_material_1'), dataIndex: 'stuff', width: 100, ellipsis: true },
      { title: this.$t('remark'), dataIndex: 'remark', width: 100, ellipsis: true }
    ]
  }

  get schema() {
    return [
      {
        title: this.$t('actions'),
        key: 'action',
        width: 80,
        customRender: (text, record) => {
          return (
            <a-popconfirm title={this.$t('page_resource_pool_confirm_delete')}
                          onConfirm={() => {
                            this.onDelete(record.key)
                          }}
                          okText={this.$t('yes')}
                          cancelText={this.$t('no')}
            >
              <a class="del-color">
                {this.$t('delete')}
              </a>
            </a-popconfirm>
          )
        }
      },
      {
        title: this.$t('page_business_material'),
        key: 'materialId',
        width: 130,
        customRender: (text, record) => {
          return (
            <a-select showSearch value={record.nameCode} style="width: 120px" onSelect={value => this.changeMaterial(value, record)}>
              {this.filterMaterialList.map(res => {
                return ( <a-select-option value={res.value}>{res.label}</a-select-option> )
              })}
            </a-select>
          )
        }
      },
      { title: this.$t('page_business_material_type'), dataIndex: 'typeName', width: 100, ellipsis: true },
      { title: this.$t('page_business_material_1'), dataIndex: 'stuff', width: 100, ellipsis: true },
      { title: this.$t('remark'), dataIndex: 'remark', width: 100, ellipsis: true }
    ]
  }
  // 关联物料
  name = 'Material'
  options = {
    retrieve: wmsp.pageWarehouseMaterialStock.bind(wmsp),
    create: wmsp.createWarehouseMaterialStock.bind(wmsp),
    delete: wmsp.deleteWarehouseMaterialStock.bind(wmsp)
  }
  acl = {
    create: 'page_business_associated_material',
    delete: 'page_business_delete_association'
  }

  hidden = ['create' ,'edit', 'delete']
  showSearch = false // 不显示搜索框
  waitGetData = true
  scroll = { x: 1200, y: 300 }
  showTableCheckbox = false
  materialTypeList = []
  materialList = []
  filterMaterialList = []
  formInfo = []
  count = 0

  get createModalTitle() {
    return this.$t('page_business_associated_material')
  }

  get createModalSaveBtn() {
    return this.$t('page_business_association')
  }

  get lang() {
    return {
      create: this.$t('page_business_associated_material'),
      placeholder: this.$t('keyword'),
      search: this.$t('search'),
      delete: this.$t('page_business_delete_association')
    }
  }

  @Watch('areaId')// 库区
  handleAreaIdChange(val) {
    this.dataSource = []
  }

  @Watch('locationId') // 库位
  handleLocationIdChange(val) {
    this.getData()
    this.hidden = this.isBind === 1 ? ['edit', 'delete'] : ['create' ,'edit', 'delete']
  }
  

  @Watch('showDialog')
  handleDialogChange(val) {
    if (val) {
      this.formInfo = []
      this.count = 0
      this.getMaterialList()
    }
  }

  render() {
    return this.customTableRender()
  }

  created() {
    this.getMaterialTypeList()
  }

  async getData(
    current = 1,
    size = this.filters.size,
    keyWords = this.keywords,
    reload: any = false
  ) {
    if (reload) current = 1
    const fetchFn = this.options.retrieve

    const { records, total: t, size: s, current: c } = await fetchFn(
      current,
      this.locationId,
      size
    )
    records.map((item, index) => item.order = index + 1)

    this.dataSource = records
    this.filters = {
      total: Number(t),
      size: Number(s),
      current: Number(c)
    }
  }

  async createDataA() {
    const list = this.formInfo.filter(res => res.materialId != '')
    if(list && list.length){
      const value = this.formInfo.map(res => {return {areaId: this.areaId,locationId: this.locationId,materialId: res.materialId}})
      const fetchFn = this.options.create
      await fetchFn({warehouseMaterialStockDTOList:value})
      this.$message.success(this.$t('page_business_association_successfully'))
      this.showDialog = false
      this.getData()
    } else {
      this.showDialog = false
    }
  }

  async getMaterialTypeList() {
    let res = await mtsp.getMaterialTypeList()
    this.materialTypeList = res.map(item => ({ label: item.name, value: item.id }))
    // console.log('materialTypeList:', this.materialTypeList)
  }

  // 可以关联的物料列表
  async getMaterialList() {
    let res = await msp.getMaterialListCanRelate(this.areaId, this.locationId)
    this.materialList = res
    this.filterMaterialList = res.map(item => ({ label: item.name + '-' + item.code, value: item.name + '-' + item.code }))
  }
  
  onDelete(key) {
    const formInfo = [...this.formInfo];
    this.formInfo = formInfo.filter(item => item.key !== key);
  }

  changeMaterial(value,record) {
    const { materialList, formInfo } = this
    const target = materialList.find(res => (res.name + '-' + res.code) === value)
    const targetValue = formInfo.find(res => res.key === record.key)
    const targetCheck = formInfo.find(res => res.materialId === value)
    if(targetCheck){
      this.$message.warning('不能选择相同物料')
      return
    }
    if(target && targetValue){
      targetValue.nameCode = target.name + '-' + target.code
      targetValue.materialId = target.id
      targetValue.typeName = target.typeName
      targetValue.stuff = target.stuff
      targetValue.remark = target.remark
      this.formInfo = formInfo
      console.log(this.formInfo)
    }
  }
}
